import React, { createContext, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getSessionItem, setSessionItem } from "../utils/helper/session";
import { updateUserRequest } from "../services/wisdomServices/userService";

const OnboardingContext = createContext();

export const useOnboarding = () => useContext(OnboardingContext);

const flow = [
  "/summary",
  "/diary",
  "/profile/links",
  "/profile/requests",
  "/profile/info",
  "/profile/payment"
];

export const OnboardingProvider = ({ children }) => {
  const navigate = useNavigate();
  const user = getSessionItem("User");

  const [currentStepIndex, setCurrentStepIndex] = useState(0);
  const [runTour, setRunTour] = useState(
    user?.isFirstLogin === true
  );

  const goToNextPage = async () => {
    const nextIndex = currentStepIndex + 1;

    if (nextIndex < flow.length) {
        setCurrentStepIndex(nextIndex);

        setRunTour(false);

        navigate(flow[nextIndex]);

        setTimeout(() => {
        setRunTour(true);
        }, 200);
    } else {
        finishOnboarding();
    }
  };

  const finishOnboarding = async () => {
    try {
      const updatedUser = {
        ...user,
        isFirstLogin: false
      };
  
      const data = {
          isFirstLogin: false
      }
      await updateUserRequest(user.id, data)
      setSessionItem("User", updatedUser);
      
    } catch (error) {
      console.error("Error: ", error)
      
    } finally {
      setRunTour(false);

    }
  };

  return (
    <OnboardingContext.Provider
      value={{
        runTour,
        setRunTour,
        goToNextPage,
        finishOnboarding
      }}
    >
      {children}
    </OnboardingContext.Provider>
  );
};